export class SurveySearchParams {
  fiscalYearId: number = 0;
  surveyTypeId: number = 0;
}

